import { cn } from "@utils/tw"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Spacer",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/spacer", (props) => {
  return (
    <div
      className={cn(
        "w-full",
        props.type === "small" && "mt-7",
        props.type === "large" && "mt-10",
        props.type === "negative-small" && "-mt-7",
        props.type === "negative-large" && "-mt-[calc(var(--spacing-10)+var(--spacing-7))]",
      )}
    >
      {env.admin && (
        <div className="w-full py-5 bg-grey-light flex items-center justify-center">
          <pre>Spacer</pre>
        </div>
      )}
    </div>
  )
})
